import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7e3085e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkout-backdrop" }, null, -1))
const _hoisted_3 = { class: "checkout-container" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = {
  key: 0,
  class: "allowlist-message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " The creator is finalizing eligibility requirements. Please check back later. ", -1))
const _hoisted_11 = [
  _hoisted_10
]

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import dayjs from 'dayjs/esm/index';
import calendar from 'dayjs/esm/plugin/calendar';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import BuyWithCardPage from '@/components/checkout/BuyWithCardPage.vue';
import BuyWithEthPage from '@/components/checkout/BuyWithEthPage.vue';
import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
import ChoosePaymentMethodPage from '@/components/checkout/ChoosePaymentMethodPage.vue';
import Spinner from '@/components/Spinner.vue';
import * as telemetry from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyButton',
  setup(__props) {

_useCssVars(_ctx => ({
  "60e4a26e": (_unref(store).clientColors.themePrimary)
}))

dayjs.extend(calendar);
dayjs.extend(relativeTime);

const CalendarFormat = {
  sameDay: '[today] [at] h:mm A', // today at 2:30 PM
  nextDay: '[tomorrow] [at] h:mm A', // tomorrow at 2:30 PM
  nextWeek: 'MMM D YYYY [at] h:mm A', // Feb 5 2023, at 2:30 PM
  lastDay: '[yesterday] h:mm A', // yesterday at 2:30 PM
  lastWeek: '[last] dddd [at] h:mm A', // last Monday at 2:30 PM
  sameElse: 'MMM D YYYY [at] h:mm A' // Mar 1 2023 at 2:30 PM
};

const DEAD_ADDRESS = '0x000000000000000000000000000000000000000000000000000000000000dead';
const store = useClaimStore();

const isModalOpen = ref(false);
const checkoutState = ref<'payment-method' | 'buy-with-eth' | 'buy-with-card'>('buy-with-eth');

const goToBuyWithEth = () => {
  telemetry.paymentPreview('eth');
  checkoutState.value = 'buy-with-eth';
};

const goToBuyWithCard = () => {
  telemetry.paymentPreview('card');
  checkoutState.value = 'buy-with-card';
};

const open = () => {
  if (store.canPayWithCard && store.isCrossmintVerified) {
    checkoutState.value = 'payment-method';
    telemetry.paymentMethodsPreview();
  } else {
    checkoutState.value = 'buy-with-eth';
    telemetry.paymentPreview('eth');
  }

  isModalOpen.value = true;
};

const allowlistUpdating = computed(() => {
  return store.merkleRoot === DEAD_ADDRESS;
});

const close = () => {
  isModalOpen.value = false;
};

const mintButtonLabel = computed(() => {
  if (store.cost.eq(0)) {
    return 'Claim Now';
  } else {
    return 'Buy Now';
  }
});

function getCalendarString (dayjsDate: dayjs.Dayjs | null) {
  return dayjsDate?.calendar(null, CalendarFormat) || '';
}

const claimStartDate = computed(() => {
  if (store.startDate) {
    return dayjs(store.startDate);
  }
  return null;
});

const claimEndDate = computed(() => {
  if (store.endDate) {
    return dayjs(store.endDate);
  }
  return null;
});

// Need this to make sure the modal height is correct on Safari
const vh95 = ref('0px');

const setMaxHeight = () => {
  vh95.value = window.innerHeight * 0.95 + 'px';
};

onMounted(() => {
  setMaxHeight();
  window.addEventListener('resize', setMaxHeight);
});

onUnmounted(() => {
  window.removeEventListener('resize', setMaxHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TransitionRoot), { show: isModalOpen.value }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            class: "checkout",
            onClose: close
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "checkout-backdrop-enter-animation",
                "enter-from": "checkout-backdrop-enter-from-animation",
                "enter-to": "checkout-backdrop-enter-to-animation",
                leave: "checkout-backdrop-leave-animation",
                "leave-from": "checkout-backdrop-leave-from-animation",
                "leave-to": "checkout-backdrop-leave-to-animation"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "checkout-enter-animation",
                "enter-from": "checkout-enter-from-animation",
                "enter-to": "checkout-enter-to-animation",
                leave: "checkout-leave-animation",
                "leave-from": "checkout-leave-from-animation",
                "leave-to": "checkout-leave-to-animation"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(DialogPanel), {
                      class: _normalizeClass(['checkout-modal', { 'checkout-modal--card': checkoutState.value === 'buy-with-card' }]),
                      style: _normalizeStyle({ 'max-height': vh95.value })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CheckoutHeader, {
                          "on-close": close,
                          success: checkoutState.value === 'success'
                        }, null, 8, ["success"]),
                        (checkoutState.value === 'payment-method')
                          ? (_openBlock(), _createBlock(ChoosePaymentMethodPage, {
                              key: 0,
                              "on-chose-method": (method) => method === 'card'? goToBuyWithCard() : goToBuyWithEth()
                            }, null, 8, ["on-chose-method"]))
                          : (checkoutState.value === 'buy-with-eth')
                            ? (_openBlock(), _createBlock(BuyWithEthPage, {
                                key: 1,
                                "go-to-pay-with-card": goToBuyWithCard
                              }))
                            : (checkoutState.value === 'buy-with-card')
                              ? (_openBlock(), _createBlock(BuyWithCardPage, { key: 2 }))
                              : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["class", "style"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("button", {
        onClick: open,
        class: "campaign-buy-button",
        disabled: 
        _unref(store).isLoadingWeb3State
        || _unref(store).isDelegationLoading
        || _unref(store).isSoldOut
        || _unref(store).status === 'not-started'
        || _unref(store).status === 'ended'
        || _unref(allowlistUpdating)
      
      }, [
        (_unref(store).isLoadingWeb3State || _unref(store).isDelegationLoading)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              dark: ""
            }))
          : (_unref(store).status === 'not-started')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Drops " + _toDisplayString(getCalendarString(_unref(claimStartDate))), 1))
            : (_unref(store).status === 'ended')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Ended " + _toDisplayString(getCalendarString(_unref(claimEndDate))), 1))
              : (_unref(store).isSoldOut)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Sold out "))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(mintButtonLabel)), 1))
      ], 8, _hoisted_4)
    ]),
    (_unref(allowlistUpdating) && _unref(store).status === 'active' && !_unref(store).isSoldOut)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true)
  ], 64))
}
}

})